
import { Link } from 'react-router-dom';

export default function PaymentCancelledPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-close-line text-2xl text-red-600"></i>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Payment Cancelled</h1>
          
          <p className="text-lg text-gray-600 mb-8">
            Your payment was cancelled. No charges have been made to your account.
          </p>

          <div className="space-y-4 mb-8">
            <p className="text-gray-600">
              If you experienced any issues during the payment process, please don't hesitate to contact our support team.
            </p>
            
            <p className="text-gray-600">
              You can try again or reach out to us for assistance with your investment or booking.
            </p>
          </div>

          <div className="space-y-4">
            <Link
              to="/investment-packages"
              className="inline-block bg-emerald-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap mr-4"
            >
              Try Again
            </Link>
            
            <Link
              to="/contact"
              className="inline-block bg-gray-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact Support
            </Link>
          </div>

          <div className="mt-8">
            <Link
              to="/"
              className="text-emerald-600 hover:text-emerald-700 font-medium cursor-pointer"
            >
              Return to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
